import { WIDGET_OPTIONS } from '../../../shared/config/constants';
import video from '../assets/video/turbine.mp4';
import videoPoster from '../assets/video/turbine.png';
import videoTranscription from '../assets/video/turbine.vtt';

export const SENTRY_DSN = 'https://88dc5d43e9a043d78e6bc7d4f035a2de@sentry.uncinc.nl/57';

const defaults = {
  appRootId: 'measurements-root',
  apiUrl: '/data/turbine',
  measurementId: 'LIF-WTG01',
  fetchDelay: 10,
  householdUsage: 3150,
  ratedDailyOutput: 7000,
  blocks: [
    {
      key: "video",
      type: "video",
      className: "col-xl-4 col-md-6",
      file: video,
      poster: videoPoster,
      transcription: videoTranscription,
    },
    {
      key: "info",
      type: "row",
      className: "col-12 col-xl-8 col-md-6",
      blocks: [
        {
          key: "power",
          type: "measurements",
          className: "col-12 col-xl-6",
          description: "Deze windmolen levert momenteel:",
          measurements: [
            {
              point: "ActivePower",
              lottie: "stroom",
              showUnit: true,
            },
          ],
        },
        {
          key: "rpm",
          type: "measurements",
          className: "col-12 col-xl-6",
          description: "De windsnelheid bij de windmolen:",
          measurements: [
            {
              point: "WindSpeed",
              lottie: "wind",
              showUnit: true,
            },
          ],
        },
        {
          key: "desc",
          type: "summary",
          className: "col-12 u-desktop-wide-only",
          description: "Vandaag heeft deze windmolen {{day}} {{unit}} opgewekt. De actuele productie deze maand is {{month}} {{unit}} en dit jaar {{year}} {{unit}}. Hiermee wekte deze windmolen dit jaar al genoeg duurzame elektriciteit op voor circa:",
          summary: {
            value: "{{households}}",
            unit: "huishoudens",
          },
        },
      ],
    },
    {
      key: "desc",
      type: "summary",
      className: "col-12 u-desktop-down",
      description: "Vandaag heeft deze windmolen {{day}} {{unit}} opgewekt. De actuele productie deze maand is {{month}} {{unit}} en dit jaar {{year}} {{unit}}. Hiermee wekte deze windmolen dit jaar al genoeg duurzame elektriciteit op voor circa:",
      summary: {
        value: "{{households}}",
        unit: "huishoudens",
      },
    },
  ],
};

export const SETTINGS = Object.assign(defaults, window.hvcMeasurements);

/**
 * Following constants can be set on de app root elements as data attributes.
 *
 * @param string data-measurement-id
 *   ID of the object we want to fetch data for.
 * @param int data-fetch-delay
 *   Fetch delay in seconds, converted to miliseconds for usage in setInterval.
 * @param int data-household-usage
 *    Yearly house hold energy usage in kWh. Since the data from the API is in MWh we turn this into MWh here.
 * @param int rated-daily-output
 *    Daily output in kWh.
 * @param string image-src
 *    URL for an image to display on the left.
 */
export const MEASUREMENT_ID = WIDGET_OPTIONS?.measurementsOptions?.measurementId || SETTINGS.measurementId || 'LIF-WTG01';
export const FETCH_DELAY = (WIDGET_OPTIONS?.measurementsOptions?.fetchDelay || SETTINGS.fetchDelay || 10) * 1000;
export const HOUSEHOLD_USAGE = (WIDGET_OPTIONS?.measurementsOptions?.householdUsage || SETTINGS.householdUsage || 3150) / 1000;
export const RATED_DAILY_OUTPUT = WIDGET_OPTIONS?.measurementsOptions?.ratedDailyOutput || SETTINGS.ratedDailyOutput || 7000;
export const IMAGE_SRC = WIDGET_OPTIONS?.measurementsOptions?.imageSrc || SETTINGS.imageSrc || "https://www.hvcgroep.nl/sites/default/files/styles/crop_quote_long/public/2019-09/_MG_0795-AvtHul20171103.jpg?h=287d9d0d&itok=LG6Io7JV";
